export function tryJsonParse<T>(json: unknown): T | undefined {
  try {
    if (json && typeof json === "string") {
      return JSON.parse(json)
    }
  } catch {
    // no-op
  }
  return undefined
}

export function safeJsonParse<T>(json: unknown, replaceWith: T): T {
  return tryJsonParse<T>(json) || replaceWith
}

export function tryJsonStringify<T>(obj: T): string | undefined {
  try {
    return JSON.stringify(obj)
  } catch {
    // no-op
  }
  return undefined
}

export function safeJsonStringify<T>(obj: T, replaceWith = ""): string {
  return tryJsonStringify(obj) || replaceWith
}
